module.exports = __webpack_public_path__ + "static/media/AB_PW7_4.f2d8ccd3.jpg";